import React from "react"
// ----------------------------------
import Header from "../components/header";
import Footer from "../components/footer";
import "../css/app.scss"

export default function Layout ({children}) {
  return (
    <>
      <Header />
      <main>{children}</main>
      <Footer />
    </>
  )
}